export default __webpack_public_path__ + "static/media/github.4da5e4a9.svg";